/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ owner: NonNullable<unknown> }} Agent_Access_Title_OwnerInputs */



/**
* | output |
* | --- |
* | "{owner}, who set this agent to run automatically, no longer has access to:" |
*
* @param {Agent_Access_Title_OwnerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_title_owner = /** @type {((inputs: Agent_Access_Title_OwnerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Title_OwnerInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Person, der dieser Auslöser gehört (${i?.owner}), hat keinen Zugriff mehr auf:`)
	return /** @type {LocalizedString} */ (`${i?.owner}, who set this agent to run automatically, no longer has access to:`)
});